import React from "react";
import i18n from "../../i18n";
import {
  IndexPagePreviewWebBlockContainerStyled,
  IndexPagePreviewWebBlockContentStyled,
  IndexPagePreviewWebBlockContentContainerStyled,
  IndexPagePreviewWebBlockImageStyled,
  IndexPagePreviewWebBlockImageFilterStyled
} from "./IndexPage.style";
import TouchEffect from "../../components/TouchEffect/TouchEffect";

export default class PreviewWebBlock extends React.Component {
  render() {
    return (
      <IndexPagePreviewWebBlockContainerStyled>
        <h1 dangerouslySetInnerHTML={{__html: i18n.t("hotify__title")}} />

        <IndexPagePreviewWebBlockContentContainerStyled>
          <IndexPagePreviewWebBlockContentStyled>
            <h2 dangerouslySetInnerHTML={{__html: i18n.t("preview_web_block__title")}} />
            <button onClick={this.props.onBlockClick}>
              <SvgFireIcon />
              <span dangerouslySetInnerHTML={{__html: i18n.t("preview_web_block__button")}} />
              <TouchEffect />
            </button>
            <p dangerouslySetInnerHTML={{__html: i18n.t("preview_web_block__text")}} />
          </IndexPagePreviewWebBlockContentStyled>
          <IndexPagePreviewWebBlockImageStyled>
            <IndexPagePreviewWebBlockImageFilterStyled></IndexPagePreviewWebBlockImageFilterStyled>
          </IndexPagePreviewWebBlockImageStyled>
        </IndexPagePreviewWebBlockContentContainerStyled>
      </IndexPagePreviewWebBlockContainerStyled>
    );
  }
}

const SvgFireIcon = () => {
  return (
    <svg viewBox="0 0 18 21" fill="none">
      <path d="M3.92871 20.77C2.95605 20.77 2.21484 20.5181 1.70508 20.0142C1.20117 19.5103 0.949219 18.7778 0.949219 17.8169V9.25635C0.949219 8.28955 1.20117 7.55713 1.70508 7.05908C2.21484 6.55518 2.95605 6.30322 3.92871 6.30322H6.43359V8.25439H4.08691C3.7002 8.25439 3.4043 8.354 3.19922 8.55322C3 8.74658 2.90039 9.04541 2.90039 9.44971V17.6147C2.90039 18.019 3 18.3179 3.19922 18.5112C3.4043 18.7104 3.7002 18.8101 4.08691 18.8101H13.9043C14.2852 18.8101 14.5781 18.7104 14.7832 18.5112C14.9883 18.3179 15.0908 18.019 15.0908 17.6147V9.44971C15.0908 9.04541 14.9883 8.74658 14.7832 8.55322C14.5781 8.354 14.2852 8.25439 13.9043 8.25439H11.5576V6.30322H14.0713C15.0439 6.30322 15.7822 6.55518 16.2861 7.05908C16.7959 7.55713 17.0508 8.28955 17.0508 9.25635V17.8169C17.0508 18.7778 16.7959 19.5103 16.2861 20.0142C15.7822 20.5181 15.0439 20.77 14.0713 20.77H3.92871ZM8.99121 13.5366C8.74512 13.5366 8.53418 13.4487 8.3584 13.2729C8.18262 13.0972 8.09473 12.8921 8.09473 12.6577V3.9126L8.17383 2.62061L7.73438 3.20947L6.55664 4.46631C6.39258 4.63623 6.19043 4.72119 5.9502 4.72119C5.73926 4.72119 5.55469 4.65088 5.39648 4.51025C5.24414 4.36963 5.16797 4.18799 5.16797 3.96533C5.16797 3.75439 5.25 3.56396 5.41406 3.39404L8.29688 0.625488C8.41992 0.508301 8.53711 0.429199 8.64844 0.388184C8.75977 0.341309 8.87402 0.317871 8.99121 0.317871C9.11426 0.317871 9.23145 0.341309 9.34277 0.388184C9.45996 0.429199 9.57715 0.508301 9.69434 0.625488L12.5771 3.39404C12.7412 3.56396 12.8232 3.75439 12.8232 3.96533C12.8232 4.18799 12.7441 4.36963 12.5859 4.51025C12.4277 4.65088 12.2432 4.72119 12.0322 4.72119C11.792 4.72119 11.5928 4.63623 11.4346 4.46631L10.2656 3.20947L9.82617 2.62061L9.89648 3.9126V12.6577C9.89648 12.8921 9.80859 13.0972 9.63281 13.2729C9.46289 13.4487 9.24902 13.5366 8.99121 13.5366Z" />
    </svg>
  );
};
